<template lang="pug">
  #app
    transition(name="slide-fade" mode="out-in")
        template(v-if="this.$route.meta.layout == 'start'")
          StartLayout
        template(v-else)
            .page
              .page-content
                .requisites(v-if="$store.state.requisites && currentPath && !isHidden")
                  .requisites__title Чтобы начать продавать билеты через TiWO, нужно заключить договор
                  a(href="#").requisites__btn Заполнить реквизиты
                  a(href="#" @click.prevent='isHidden = true').requisites__close
                    svgicon(name="close")
                Header
                transition(name="slide-fade" mode="out-in")
                  component(:is="layout" v-if="layout == 'sidebarLayout'")
                    router-view
                  template(v-else)
                    router-view
              Footer
</template>

<script>


import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import SidebarLayout from '@/layouts/SidebarLayout.vue'
import StartLayout from '@/layouts/StartLayout.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    SidebarLayout,
    StartLayout
  },
  data: function() {
    return {
      isHidden: false,
    }
  },
  computed: {
    currentPath() {
      return this.$route.name != 'home';
    },
    layout() {
      return (this.$route.meta.layout) + 'Layout'
    },
  },
}
</script>

<style lang="scss">
@import "@/assets/style/main.scss";

.requisites{
  padding: 15px 40px;
  background-color: #008cff;
  background-image: linear-gradient(to right, #008cff 0%, #b533eb 100%);
  display: flex;
  align-items: center;
  &__title{
    color: #fff;
    font-size: 22px;
    margin-right: 20px;
  }
  &__btn{
    color: #fff;
    font-size: 20px;
    font-weight: 700;
    border-radius: 25px;
    border: 1px solid rgba(#ccc, 0.5);
    padding: 15px 23px;
    text-decoration: none;
    flex-shrink: 0;
    margin-right: 30px;
    &:hover{
      color: #008cff;
      background-color: #fff;
    }
  }
  &__close{
    margin-left: auto;
    .svg-icon{
      display: block;
      color: #fff;  
    }
    &:hover{
      transition: transform 0.35s;
      transform: rotate(180deg);
    }
  }
}

@media (max-width: 991px)  {
  .requisites{
    padding-left: 20px;
    padding-right: 20px;
    &__title{
      margin-bottom: 10px;
      font-size: 16px;
      line-height: 20px;
    }
    &__btn{
      font-size: 14px;
      padding: 9px 13px;
    }
  }
}
@media (max-width: 767px)  {
  .requisites{
    position: relative;
    flex-direction: column;
    text-align: center;
    &__title{
      margin-bottom: 10px;
      font-size: 15px;
      line-height: 20px;
    }
    &__btn{
      font-size: 14px;
      padding: 9px 13px;
      margin-right: 0;
    }
    &__close{
      position: absolute;
      top: 15px;
      right: 15px;
    }
  }
}
</style>
